import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useConditionalBackground } from "@/contexts/useConditionalBackground";
import {
  EDGE_COLUMN_PX,
  tableCellStylesThin,
  tableHeaderStylesThin,
} from "@/components/FinancialShared/tableStyles";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { formatDateWithNoHours } from "@/utils/formatDateWithNoHours";
import { IResumoFinanceiroCobrancaRetorno } from "@/models/consignado/proposal-billings.model";

type Props = {
  resumo: IResumoFinanceiroCobrancaRetorno;
};

const dataOuTraco = (data: string | null) => (data ? formatDateWithNoHours(data) : "—");

export default function ResumoFinanceiro({ resumo }: Props) {
  const backgroundStyle = useConditionalBackground();

  return (
    <TableContainer borderRadius="lg" overflowX="auto">
      <Table variant="simple" size="sm">
        <Thead {...backgroundStyle}>
          <Tr>
            <Th {...tableHeaderStylesThin} px={EDGE_COLUMN_PX}>Valor financiado</Th>
            <Th {...tableHeaderStylesThin}>Total pago</Th>
            <Th {...tableHeaderStylesThin}>Parcelas</Th>
            <Th {...tableHeaderStylesThin}>Saldo devedor total</Th>
            <Th {...tableHeaderStylesThin}>Primeiro vencimento</Th>
            <Th {...tableHeaderStylesThin}>Último vencimento</Th>
            <Th {...tableHeaderStylesThin} px={EDGE_COLUMN_PX}>Assinatura do contrato</Th>
            {resumo.motivo_encerramento && (
              <Th {...tableHeaderStylesThin}>Motivo do encerramento</Th>
            )}
            {resumo.data_desligamento && (
              <Th {...tableHeaderStylesThin} px={EDGE_COLUMN_PX}>Desligamento</Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td {...tableCellStylesThin} px={EDGE_COLUMN_PX}>
              {BrlCurrencyFormatter(resumo.valor_financiado)}
            </Td>
            <Td {...tableCellStylesThin}>{BrlCurrencyFormatter(resumo.total_pago)}</Td>
            <Td {...tableCellStylesThin}>
              {`${resumo.numero_parcelas}x de ${BrlCurrencyFormatter(resumo.valor_parcela)}`}
            </Td>
            <Td {...tableCellStylesThin}>
              {BrlCurrencyFormatter(resumo.saldo_devedor_total)}
            </Td>
            <Td {...tableCellStylesThin}>{dataOuTraco(resumo.primeiro_vencimento)}</Td>
            <Td {...tableCellStylesThin}>{dataOuTraco(resumo.ultimo_vencimento)}</Td>
            <Td {...tableCellStylesThin} px={EDGE_COLUMN_PX}>
              {dataOuTraco(resumo.assinatura_contrato)}
            </Td>
            {resumo.motivo_encerramento && (
              <Td {...tableCellStylesThin}>{resumo.motivo_encerramento}</Td>
            )}
            {resumo.data_desligamento && (
              <Td {...tableCellStylesThin} px={EDGE_COLUMN_PX}>
                {dataOuTraco(resumo.data_desligamento)}
              </Td>
            )}
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
}
